import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { SkipLink } from '@/components/accessibility/SkipLink';

export const Route = createFileRoute('/_marketing')({
  component: MarketingLayout,
});

function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink targetId="main-content" />
      <Header />
      <main id="main-content" role="main" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
